import { StoragePoolsView } from "@/admin/buckets/StoragePoolsView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/storage_pools")({
    component: StoragePoolsView,
});
